// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();
//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       }
//         // ---- NEW: fallback to global lookup when thumbnails not inside this element ----
//       // Try to extract numeric section id from the media-gallery id "MediaGallery-<sectionId>"
//       const idParts = (this.id || '').split('-');
//       const sectionId = idParts.length ? idParts.slice(1).join('-') : null;

//       if (!this.elements.thumbnails && sectionId) {
//         // look for the thumbnail slider outside the component by exact id first
//         const globalById = document.getElementById(`GalleryThumbnails-${sectionId}`);
//         // then fallback to any matching id-starting-with
//         const globalQuery = document.querySelector(`[id^="GalleryThumbnails-${sectionId}"], [id^="GalleryThumbnails"]`);
//         this.elements.thumbnails = globalById || globalQuery || this.elements.thumbnails;
//       }
//       // ---------------------------------------------------------------------------------
//       this.mql = window.matchMedia('(min-width: 750px)');
//       if (!this.elements.thumbnails) return;

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//       });
//       if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();

//               // Ensure viewer exists
//                 if (!this.elements.viewer) return;

//                 // --- IntersectionObserver setup ---
//                 this.lastActiveId = null;
//                 this.scrollObserver = new IntersectionObserver((entries) => {
//                   entries.forEach(entry => {
//                     if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//                       const mediaId = entry.target?.dataset?.mediaId;
//                       if (mediaId && mediaId !== this.lastActiveId) {
//                         this.lastActiveId = mediaId;
//                         this.setActiveMedia(mediaId, false, true); // smooth scroll only for observer
//                       }
//                     }
//                   });
//                 }, {
//                   root: null,   // viewport
//                   threshold: 0.5
//                 });

//                 // Observe all media slides
//                 this.elements.viewer.querySelectorAll('[data-media-id]').forEach(media => {
//                   if (media.dataset?.mediaId) this.scrollObserver.observe(media);
//                 });
//   }

//     onSlideChanged(event) {
//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

//    setActiveMedia(mediaId, prepend) {
//       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//         element.classList.remove('is-active');
//       });
//       activeMedia.classList.add('is-active');

//       if (prepend) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//           activeThumbnail.parentElement.prepend(activeThumbnail);
//         }
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//       // ---- NEW: CENTER MAIN SLIDE LIKE YOUR SCRIPT ----
//       activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

//       this.preventStickyHeader();
//       this.playActiveMedia(activeMedia);

//       if (!this.elements.thumbnails) return;
//       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//       this.setActiveThumbnail(activeThumbnail);

//       // Keep Shopify accessibility announcement
//       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//     }


//     setActiveThumbnail(thumbnail) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       // Remove Shopify aria-current
//       this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
//         element.removeAttribute('aria-current');
//       });

//       // Add active state
//       thumbnail.querySelector('button').setAttribute('aria-current', true);

//       // ---- NEW: vertical scroll logic from your working script ----
//       const container = this.elements.thumbnails;
//       const topPosition = thumbnail.offsetTop - container.clientHeight / 2 + thumbnail.clientHeight / 2;

//       container.scrollTo({
//         top: topPosition,
//         behavior: 'smooth'
//       });
//     }


//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }
//   });
// }

// extra

// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();
//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       }
//         // ---- NEW: fallback to global lookup when thumbnails not inside this element ----
//       // Try to extract numeric section id from the media-gallery id "MediaGallery-<sectionId>"
//       const idParts = (this.id || '').split('-');
//       const sectionId = idParts.length ? idParts.slice(1).join('-') : null;

//       if (!this.elements.thumbnails && sectionId) {
//         // look for the thumbnail slider outside the component by exact id first
//         const globalById = document.getElementById(`GalleryThumbnails-${sectionId}`);
//         // then fallback to any matching id-starting-with
//         const globalQuery = document.querySelector(`[id^="GalleryThumbnails-${sectionId}"], [id^="GalleryThumbnails"]`);
//         this.elements.thumbnails = globalById || globalQuery || this.elements.thumbnails;
//       }
//       // ---------------------------------------------------------------------------------
//       this.mql = window.matchMedia('(min-width: 750px)');
//       if (!this.elements.thumbnails) return;

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//       });
//       if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
//       // Observe all media items
//               this.elements.viewer.querySelectorAll('[data-media-id]').forEach(media => {
//                 // ── IntersectionObserver for scroll detection ──
//         this.lastActiveId = null; // prevent repeated activations
//         this.scrollObserver = new IntersectionObserver((entries) => {
//           entries.forEach(entry => {
//             if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//               const mediaId = entry.target.dataset.mediaId;
//               if (mediaId && mediaId !== this.lastActiveId) {
//                 this.lastActiveId = mediaId;
//                 this.setActiveMedia(mediaId, false, true); // smooth scroll optional
//               }
//             }
//           });
//         }, {
//           root: null,        // viewport
//           threshold: 0.5     // 50% visible
//         });

//         // Observe all media slides
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach(media => {
//           this.scrollObserver.observe(media);
//         });

//       });

//     }

//     onSlideChanged(event) {
//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

// setActiveMedia(mediaId, prepend = false, smooth = false) {
//   const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
//   if (!activeMedia) return;

//   this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
//   activeMedia.classList.add('is-active');

//   // Scroll behavior
//   activeMedia.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });

//   this.preventStickyHeader();
//   this.playActiveMedia(activeMedia);

//   if (!this.elements.thumbnails) return;
//   const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//   this.setActiveThumbnail(activeThumbnail, smooth);

//   this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

//   if (prepend) {
//     activeMedia.parentElement.prepend(activeMedia);
//     activeThumbnail.parentElement.prepend(activeThumbnail);
//     if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//   }
// }



//     setActiveThumbnail(thumbnail, smooth = true) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       this.elements.thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));
//       thumbnail.querySelector('button').setAttribute('aria-current', true);

//       const container = this.elements.thumbnails;
//       const topPosition = thumbnail.offsetTop - container.clientHeight / 2 + thumbnail.clientHeight / 2;
//       container.scrollTo({
//         top: topPosition,
//         behavior: smooth ? 'smooth' : 'auto'
//       });
//     }

//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }
//   });
// }

// media-gallery.js – PERFECT WORKING VERSION (Dec 2025)
// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();

//       // Find elements inside shadow or light DOM
//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       };

//       // ── Fallback: thumbnails can be outside the <media-gallery> component ──
//       if (!this.elements.thumbnails && this.id) {
//         const sectionId = this.id.split('-').slice(1).join('-');
//         if (sectionId) {
//           this.elements.thumbnails = document.getElementById(`GalleryThumbnails-${sectionId}`)
//                                   || document.querySelector(`[id^="GalleryThumbnails-${sectionId}"]`)
//                                   || document.querySelector('[id^="GalleryThumbnails"]');
//         }
//       }

//       if (!this.elements.viewer || !this.elements.thumbnails) {
//         console.warn('[MediaGallery] Missing viewer or thumbnails – aborting');
//         return;
//       }

//       // Helper to normalize Shopify's crazy IDs
//       this.normalizeId = (id) => id ? id.split('__').pop() : null;

//       // ── IntersectionObserver: auto-switch when slide becomes 50%+ visible ──
//       this.scrollObserver = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//             const cleanId = this.normalizeId(entry.target.dataset.mediaId);
//             if (cleanId && !entry.target.classList.contains('is-active')) {
//               this.setActiveMedia(cleanId, false);
//             }
//           }
//         });
//       }, {
//         root: null,
//         threshold: 0.5
//       });

//       // ── Observe all slides ──
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach(slide => {
//         this.scrollObserver.observe(slide);
//       });

//       // ── Thumbnail clicks ──
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach(thumb => {
//         thumb.querySelector('button')?.addEventListener('click', () => {
//           const cleanId = this.normalizeId(thumb.dataset.target);
//           this.setActiveMedia(cleanId, false);
//         });
//       });

//       // ── Desktop layout tweaks ──
//       this.mql = window.matchMedia('(min-width: 750px)');
//       if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) {
//         this.removeListSemantic();
//       }

//       // ── Listen to native slider events (Flickity, Swiper, etc.) ──
//       this.elements.viewer.addEventListener('slideChanged', debounce((e) => {
//         const cleanId = this.normalizeId(e.detail.currentElement.dataset.mediaId);
//         this.setActiveThumbnailById(cleanId);
//       }, 100));
//     }

//     // ── MAIN METHOD: Activate media by clean ID ──
//     setActiveMedia(mediaId, prepend = false) {
//       if (!mediaId) return;

//       // Find main slide (supports both short and long IDs)
//       const activeMedia = this.elements.viewer.querySelector(
//         `[data-media-id="${mediaId}"], [data-media-id*="__${mediaId}"]`
//       );

//       if (!activeMedia) return;

//       // Update active class
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => {
//         el.classList.remove('is-active');
//       });
//       activeMedia.classList.add('is-active');

//       // Center the slide smoothly
//       activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

//       // Play video / model
//       this.playActiveMedia(activeMedia);
//       this.preventStickyHeader();

//       // Highlight + center thumbnail
//       this.setActiveThumbnailById(mediaId);

//       // Accessibility announcement
//       const thumb = this.elements.thumbnails.querySelector(
//         `[data-target="${mediaId}"], [data-target*="__${mediaId}"]`
//       );
//       if (thumb) {
//         const position = thumb.dataset.mediaPosition || 
//                         Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'))
//                              .indexOf(thumb) + 1;
//         this.announceLiveRegion(activeMedia, position);
//       }

//       // Optional: move clicked media to first position
//       if (prepend && activeMedia.parentElement) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }
//     }

//     // ── Highlight and center thumbnail ──
//     setActiveThumbnailById(mediaId) {
//       if (!this.elements.thumbnails) return;

//       const thumbnail = this.elements.thumbnails.querySelector(
//         `[data-target="${mediaId}"], [data-target*="__${mediaId}"]`
//       );

//       if (!thumbnail) return;

//       // Update aria-current
//       this.elements.thumbnails.querySelectorAll('button').forEach(btn => {
//         btn.removeAttribute('aria-current');
//       });
//       thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');

//       // Smooth scroll thumbnail into center
//       const container = this.elements.thumbnails;
//       const thumbCenter = thumbnail.offsetTop + thumbnail.offsetHeight / 2;
//       const viewCenter = container.scrollTop + container.clientHeight / 2;

//       container.scrollTo({
//         top: thumbCenter - viewCenter + 10, // tiny offset for perfection
//         behavior: 'smooth'
//       });
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia?.();
//       const deferred = activeItem.querySelector('deferred-media');
//       if (deferred) deferred.loadContent(false);
//     }

//     preventStickyHeader() {
//       const sticky = document.querySelector('sticky-header');
//       if (sticky) sticky.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems?.forEach(item => item.setAttribute('role', 'presentation'));
//     }

//     announceLiveRegion(activeItem, position) {
//       const img = activeItem.querySelector('.product__modal-opener--image img') ||
//                   activeItem.querySelector('img');
//       if (!img || !this.elements.liveRegion) return;

//       // Force reload to trigger onload
//       img.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings?.imageAvailable
//           ?.replace('[index]', position) || `Image ${position} loaded`;
//         setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', true), 3000);
//       };
//       img.src = img.src; // trigger onload even if cached
//     }

//     disconnectedCallback() {
//       if (this.scrollObserver) this.scrollObserver.disconnect();
//     }
//   });
// }

// // Simple debounce utility
// function debounce(func, wait) {
//   let timeout;
//   return function executedFunction(...args) {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func.apply(this, args), wait);
//   };
// }

// fully working
// if(window.innerWidth > 750) {
  // if (!customElements.get('media-gallery')) {
  //   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
  //     constructor() {
  //       super();
  //       this.elements = {
  //         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
  //         viewer: this.querySelector('[id^="GalleryViewer"]'),
  //         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
  //       };

  //       // Fallback to global thumbnails
  //       const idParts = (this.id || '').split('-');
  //       const sectionId = idParts.length ? idParts.slice(1).join('-') : null;
  //       if (!this.elements.thumbnails && sectionId) {
  //         this.elements.thumbnails = document.getElementById(`GalleryThumbnails-${sectionId}`) ||
  //                                   document.querySelector(`[id^="GalleryThumbnails-${sectionId}"], [id^="GalleryThumbnails"]`);
  //       }

  //       if (!this.elements.viewer || !this.elements.thumbnails) return;

  //       this.mql = window.matchMedia('(min-width: 750px)');
  //       if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();

  //       // ---------------- CLICK HANDLERS ----------------
  //       this.userScrollLock = false; // prevent observer interference
  //       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
  //         thumb.querySelector('button')?.addEventListener('click', () => {
  //           const mediaId = thumb.dataset.target;
  //           if (!mediaId) return;

  //           this.userScrollLock = true;          // Lock observer for this click
  //           this.setActiveMedia(mediaId, false, true); // smooth scroll for click

  //           // Release lock after 500ms (after scroll finishes)
  //           setTimeout(() => { this.userScrollLock = false; }, 800);
  //         });
  //       });


  //       // ---------------- OBSERVER ----------------

  //         // ------------------------------------
  //         // DEBUG SWITCH
  //         // ------------------------------------
  //         const DEBUG = false; // turn ON/OFF logs 
  //         this.lastActiveId = null;
  //   const VISIBILITY_SWITCH_THRESHOLD = 0.60;
  //   const VISIBILITY_MARGIN = 0.15;

  //   this.visibilityMap = new Map(); // stores latest visibility scores

  //   this.scrollObserver = new IntersectionObserver((entries) => {
  //     if (this.userScrollLock) return;

  //     entries.forEach(entry => {
  //       const id = entry.target.dataset.mediaId;
  //       if (!id) return;
  //       this.visibilityMap.set(id, entry.intersectionRatio);
  //     });

  //     // find the most visible item from all tracked items
  //     let bestId = null;
  //     let bestRatio = 0;

  //     this.visibilityMap.forEach((ratio, id) => {
  //       if (ratio > bestRatio) {
  //         bestId = id;
  //         bestRatio = ratio;
  //       }
  //     });

  //     if (!bestId) return;

  //     const currentId = this.lastActiveId;
  //     const currentRatio = this.visibilityMap.get(currentId) || 0;

  //     if (DEBUG) console.log(`🔎 Compare: new=${bestRatio.toFixed(2)} vs current=${currentRatio.toFixed(2)}`);

  //     const shouldSwitch =
  //       bestRatio >= VISIBILITY_SWITCH_THRESHOLD ||
  //       bestRatio > currentRatio + VISIBILITY_MARGIN;

  //     if (!shouldSwitch) {
  //       if (DEBUG) console.log("🚫 Not switching — stable.");
  //       return;
  //     }

  //     // skip if it's the same
  //     if (bestId === currentId) return;

  //     if (DEBUG) console.log(`🏆 Switching → ${bestId} (${bestRatio.toFixed(2)})`);

  //     this.lastActiveId = bestId;
  //     this.setActiveMedia(bestId, false, false);

  //   }, {
  //     root: null,
  //     threshold: [0, 0.15, 0.3, 0.5, 0.7, 1],
  //     rootMargin: "-10% 0px -10% 0px"
  //   });

  //     this.elements.viewer.querySelectorAll('[data-media-id]').forEach(media => {
  //       if (DEBUG) console.log(`👀 Observing →`, media.dataset.mediaId);
  //       this.scrollObserver.observe(media);
  //     });


  //     }

  //     // ---------------- METHODS ----------------
  //     setActiveMedia(mediaId, prepend = false, smooth = false) {
  //       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
  //       if (!activeMedia) return;

  //       this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
  //       activeMedia.classList.add('is-active');

  //       activeMedia.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });

  //       this.preventStickyHeader();
  //       this.playActiveMedia(activeMedia);

  //       const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
  //       this.setActiveThumbnail(activeThumbnail, smooth);

  //       if (activeThumbnail && prepend) {
  //         activeMedia.parentElement.prepend(activeMedia);
  //         activeThumbnail.parentElement.prepend(activeThumbnail);
  //         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
  //       }

  //       this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
  //     }

  //     setActiveThumbnail(thumbnail, smooth = true) {
  //       if (!this.elements.thumbnails || !thumbnail) return;
  //       this.elements.thumbnails.querySelectorAll('button').forEach(btn => btn.removeAttribute('aria-current'));
  //       thumbnail.querySelector('button')?.setAttribute('aria-current', true);

  //       const container = this.elements.thumbnails;
  //       const topPosition = thumbnail.offsetTop - container.clientHeight / 2 + thumbnail.clientHeight / 2;
  //       container.scrollTo({ top: topPosition, behavior: smooth ? 'smooth' : 'auto' });
  //     }

  //     announceLiveRegion(activeItem, position) {
  //       const image = activeItem.querySelector('.product__modal-opener--image img');
  //       if (!image || !this.elements.liveRegion) return;
  //       image.onload = () => {
  //         this.elements.liveRegion.setAttribute('aria-hidden', false);
  //         this.elements.liveRegion.innerHTML = window.accessibilityStrings?.imageAvailable?.replace('[index]', position)
  //                                           || `Image ${position} loaded`;
  //         setTimeout(() => { this.elements.liveRegion.setAttribute('aria-hidden', true); }, 2000);
  //       };
  //       image.src = image.src; // trigger onload
  //     }

  //     playActiveMedia(activeItem) {
  //       window.pauseAllMedia?.();
  //       const deferredMedia = activeItem.querySelector('deferred-media');
  //       if (deferredMedia) deferredMedia.loadContent(false);
  //     }

  //     preventStickyHeader() {
  //       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
  //       if (!this.stickyHeader) return;
  //       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  //     }

  //     removeListSemantic() {
  //       if (!this.elements.viewer.slider) return;
  //       this.elements.viewer.slider.setAttribute('role', 'presentation');
  //       this.elements.viewer.sliderItems?.forEach(slide => slide.setAttribute('role', 'presentation'));
  //     }
  //   });
  // }
// }
// else {
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

// }
